module.exports = __webpack_public_path__ + "img/redstep01.ac4ce647.png";